<div class="wrapper">
    <div class="dropzone" fileDrop [allowedExtensions]="this.fileFormats!" (filesChangeEmitter)="onFileChange($event)">
        <mat-icon>file_upload</mat-icon>
        <input type="file" name="file" id="file" (click)="resetChangeDetection()"
            (change)="onFileChange($event.target)" [multiple]="true"/>
        <label for="file">
            <div class="subheader">
                Drag and drop your file or <span class="textLink pointer">browse</span><br />
            </div>
        </label>
    </div>
    @for (file of this.fileList; track file) {
    @if (file.displayName) {
    <div class="grid">
        <div class="fileItem">
            <div class="file-icon">
                <strong>{{ file.fileExtension }}</strong>
            </div>
            <strong>{{ file.displayName }}</strong>
        </div>
        <div class="actions flex-row align-center">
            @if (file.status === "completed") {
            <mat-icon class="pointer" (click)="deleteFile(file)">delete</mat-icon>
            } @else {
            <mat-icon class="pointer" (click)="deleteFile(file)">cancel</mat-icon>
            }
        </div>
        <div>
            @if (!["completed", "processed", "uploaded"].includes(file.status)) {
            <mat-spinner [diameter]="24"></mat-spinner>
            } @else {
            <div class="circle">
                <mat-icon class="done-icon">done</mat-icon>
            </div>
            }
        </div>
    </div>
    }
    }
    @for (file of this.tempFiles; track file) {
    @if (file.displayName) {
    <div class="grid">
        <div class="fileItem">
            <div class="file-icon">
                <strong>{{ file.fileExtension }}</strong>
            </div>
            <span>{{ file.displayName }}</span>
        </div>
        <div class="actions flex-row align-center">

            <mat-icon class="pointer" (click)="deleteFile(file)">cancel</mat-icon>
        </div>
        <div>

            <mat-spinner [diameter]="24"></mat-spinner>

        </div>
    </div>
    }
    }
</div>
